import { Box, Flex, Stack } from '@chakra-ui/react'
import React from 'react'
import { AppFooter } from '../../components/AppFooter'
import { AppHeader } from '../../components/AppHeader'
import { useAuth, useClientRect } from '../../hooks'
import { ApexMenu } from '../ApexMenu'
import { LayoutContext } from '../contexts/layout/LayoutContext'

export interface Props {
  children: JSX.Element | JSX.Element[]
}

const Layout = ({ children }: Props) => {
  const { handleSignout, showAppContent } = useAuth()
  const [headerRect, headerRef] = useClientRect()
  const [footerRect, footerRef] = useClientRect()
  const headerHeight = headerRect?.height || 0
  const footerHeight = footerRect?.height || 0

  return (
    <Stack height="100vh" className="layout-container" spacing={0}>
      <Box zIndex="sticky" ref={headerRef} key={`header-${showAppContent}`}>
        <AppHeader title="Accounts" />
        <ApexMenu handleSignout={handleSignout} />
      </Box>
      <LayoutContext.Provider
        value={{
          headerHeight,
          footerHeight,
        }}
      >
        <Flex
          flexDirection="column"
          flexGrow={1}
          height={`calc(100vh - ${headerHeight + footerHeight}px)`}
        >
          {children}
        </Flex>
      </LayoutContext.Provider>
      <Box zIndex="sticky" ref={footerRef}>
        <AppFooter />
      </Box>
    </Stack>
  )
}

export default Layout
